import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import BinanceLogo from '../../images/binance-logo.svg';
import HuobiLogo from '../../images/huobi-logo.svg';
import LiqualityLogo from '../../images/liquality-logo.svg';
import OkexLogo from '../../images/okex-logo.svg';
import Modal from '../common/modal/Modal';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0 30px 0;

    h2 {
        color: #72727A !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 150%;
        text-align: center;
        margin: 20px 0 30px 0;
    }

    a {
        border: 2px solid #F5F5F3;
        border-radius: 8px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 110px;
        margin: 10px 0;
        transition: 100ms;

        :hover {
            border-color: #8FCDFF;
            background-color: #F0F9FF;
        }
    }
`;

const WhereToBuyNearModal = ({ open, onClose }) => {
    return (
        <Modal
            id='where-to-buy-modal'
            isOpen={open}
            onClose={onClose}
            closeButton='true'
            modalSize='md'
        >
            <Container>
                <h1><Translate id='account.createImplicit.pre.whereToBuy.title'/></h1>
                <h2><Translate id='account.createImplicit.pre.whereToBuy.desc'/></h2>
                <a href='https://www.binance.com/' target='_blank' rel='noreferrer'>
                    <img src={BinanceLogo} alt='BINANCE'/>
                </a>
                <a href='https://www.huobi.com/' target='_blank' rel='noreferrer'>
                    <img src={HuobiLogo} alt='HUOBI'/>
                </a>
                <a href='https://www.okex.com/' target='_blank' rel='noreferrer'>
                    <img src={OkexLogo} alt='OKEX'/>
                </a>
                <a href='https://liquality.io/' target='_blank' rel='noreferrer'>
                    <img src={LiqualityLogo} alt='LIQUALITY'/>
                </a>
            </Container>
        </Modal>
    );
};

export default WhereToBuyNearModal;